<template>
  <div>
    <div style="background: black; padding: 3px">
      <div v-if="useProvidedIcon" class="logo-box" :style="logoBoxStyle">
        <div width="512" :style="providedImageStyle" alt="logo" />
        <div v-if="hasFlag" class="flag" :style="flagStyle">{{ flagText }}</div>
      </div>
      <div v-else ref="logoGenerated" class="logo-box" :style="logoBoxStyle">
        <div class="logo" :style="`width:${size}px;height:${size}px;border-radius:${borderRadius}px;`">
          <div class="logo-top" :style="logoTopStyle">
            <img
              :style="`height:${unit * 13}px;max-width:${size - 2}px;max-height:${unit * 26}px;color:red`"
              :src="assetUrl('logo_small_light.png')"
              alt="logo"
            />
          </div>
          <div class="logo-bottom" :style="bottomStyle">öV-Pad WebApp</div>
          <div v-if="hasFlag" class="flag" :style="flagStyle">{{ flagText }}</div>
        </div>
      </div>
    </div>
    <div style="padding-top: 10px; background: white">{{ svg }}</div>
  </div>
</template>

<script>
import { cssColor } from '@/common/utils';
import configs from '@/common/config';
import { mapState } from 'vuex';
import common from '@/mixins/common';

export default {
  name: 'LogoGenerated',
  mixins: [common],
  props: {
    size: {
      type: Number,
      default: 46,
    },
  },
  created() {
    this.apiUrl = configs.apiUrl;
  },
  mounted() {
    this.svg = this.getAsSvg();
  },

  data() {
    return {
      currentTheme: 'light',
      inverted: true,
      flagText: null,
      svg: '',
      useProvidedIcon: false,
      providedIcon: 'icon-512x512.png',
    };
  },
  methods: {
    cssColor(functionalColor) {
      let vuetify = this.$vuetify;
      return vuetify.theme.themes[vuetify.theme.dark ? 'dark' : 'light'][functionalColor];
    },

    onImgLoad() {
      console.debug('image loaded');
    },
    getAsSvg() {
      if (this.$refs.logoGenerated) {
        var data =
          "<svg xmlns='http://www.w3.org/2000/svg' width='" +
          512 +
          "px' height='" +
          512 +
          "px'>" +
          "<foreignObject width='100%' height='100%'>" +
          "<div xmlns='http://www.w3.org/1999/xhtml' >" +
          this.$refs.logoGenerated.innerHTML +
          '</div>' +
          '</foreignObject>' +
          '</svg>';

        return data;
      }
      return '';
    },
  },

  computed: {
    ...mapState({
      logoTheme: (state) => (state.theme.logo ? state.theme.logo : { bg: 'primary', fg: 'black', dark: true }),
      logoBoxStyle() {
        return {
          borderRadius: this.borderRadius + 'px !important',
          // width: this.size + 'px',
          // height: `${this.unit * 46}px`,
          width: '512px',
          height: '512px',
          overflow: 'hidden !important',
          // transform: 'scale(0.1,0.1)',
        };
      },
      logoTopStyle() {
        return {
          borderTopLeftRadius: this.borderRadius + 'px',
          borderTopRightRadius: this.borderRadius + 'px',
          width: this.size + 'px',
          height: `${this.unit * 18}px`,
          background: this.inverted ? this.cssColor(this.logoTheme.bg) : 'white',
        };
      },
      bottomStyle() {
        //console.debug('inverted=' + this.inverted, 'logoTheme.bg=' + this.logoTheme.bg, 'this.cssColor(this.logoTheme.fg)=' + this.cssColor(this.logoTheme.fg));
        return {
          borderBottomLeftRadius: this.borderRadius + 'px',
          borderBottomRightRadius: this.borderRadius + 'px',
          fontSize: '100px', // `${this.unit * 12}px`,
          lineHeight: `${this.unit * 13}px`,
          paddingTop: '14px',
          width: this.size + 'px',
          height: `${this.unit * 28}px`,
          background: this.inverted ? 'white' : this.cssColor(this.logoTheme.bg),
          color: '#404040', //${this.inverted ? this.cssColor('primary') : '#404040'};`;
        };
      },
      flagStyle() {
        return {
          fontWeight: 'bold',
          background: 'rgb(255, 193, 7)',
          height: '150px',
          width: '600px',
          fontSize: '106px',
          textAlign: 'center',
          transform: 'rotate(-45deg) translate(210px, -450px)',
        };
      },
      providedImageStyle() {
        console.debug('provided image style', `url(${this.assetUrl('icon-512x512.png')})`);
        return {
          transform: 'translateY(-5px) translateX(-5px)',
          background: `url(${this.assetUrl('icon-512x512.png')}`,
          width: '524px',
          height: '528px',
          border: '1px solid red',
          backgroundSize: 'cover',
          borderRadius: this.borderRadius + 'px !important',
          overflow: 'hidden !important',
        };
      },
      hasFlag() {
        return this.flagText !== null;
      },
    }),

    unit() {
      return this.size / 46;
    },
    borderRadius() {
      return this.unit * 5;
    },
    logoPrimaryColor() {
      return this.$vuetify.theme.themes.light.primary;
    },
    backgroundColor() {
      return this.$vuetify.theme.themes.light.primary;
    },
  },
  watch: {
    color(v) {
      this.currentTheme = this.darkMode ? 'dark' : 'light';
    },
  },
};
</script>

<style scoped>
.logo-box {
  background: transparent;
}
.logo {
  box-shadow: #202020cc 0px 2px 5px 1px;
  background: white;
  margin-right: 13px;
  margin-top: 0px;
  border: none;
}
.logo-top {
  border-style: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.logo-bottom {
  bottom: 0;
  padding-top: 1px;
  text-align: center;
  left: 0;
  right: 0;

  font-weight: bold;
}
</style>
